import React from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import PrivateRoute from "components/PrivateRoute/PrivateRoute";
import AuditAndHistoryRevisions from "./AuditAndHistoryRevisions";
import AuditAndHistoryRevisionSingleRecordDisplay from "./AuditSingleRecordDisplay/AuditAndHistoryRevisionSingleRecordDisplay";
import AuditSearch from "./AuditSearch";
import { useAppStore } from "../../stores";
import _ from "lodash";

interface IAuditAndHistoryRevisionsRouterProps {}

export default function AuditAndHistoryRevisionsRouter(
  props: IAuditAndHistoryRevisionsRouterProps
) {
  // Zustand store
  const user = useAppStore((state) => state.user);
  const permissions = user?.permissions || [];
  const authenticated = useAppStore((state) => state.authentication?.isLoginSuccess || false);

  const navigate = useNavigate();
  const location = useLocation();

  const [isAttendee, setIsAttendee] = React.useState(window.sessionStorage.getItem("isAttendee") === "true" || false);


  // this will have to change to reflect it not even showing the route in the side nav bar
  // on the dashboard if they are not admin or back office
  const loadSearch = !!_.find(
    permissions,
    (p: { name?: string }) =>
      (p.name?.indexOf("UserType.Admin") ?? -1) != -1 ||
      (p.name?.indexOf("Credential.Admin") ?? -1) != -1
  );

  React.useEffect(() => {
    if (location.pathname === "/audit-and-revisions") {
      if (loadSearch) {
        navigate("/audit-and-revisions/search");
      } else {
        // they would be pushed to the non authorized page here eventually
        alert("You are not authorized to see this");
      }
    }
    window.sessionStorage.setItem("isAttendee", isAttendee? "true" : "false");
  });

  const onRowClick = (record: any) => {
    if (record.key) {
     // history.push("/audit-and-revisions/revision/" + record.key);
    }
  };

  return (
    <Routes>
      <Route
        path="search"
        element={
          <PrivateRoute>
            <AuditSearch setIsAttendee={setIsAttendee} />
          </PrivateRoute>
        }
      />
      <Route
        path="search-results"
        element={
          <PrivateRoute>
            <AuditAndHistoryRevisions isAttendee={isAttendee} />
          </PrivateRoute>
        }
      />
      <Route
        path="revision/:revisionid"
        element={
          <PrivateRoute>
            <AuditAndHistoryRevisionSingleRecordDisplay />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}
